import { Component, Input } from '@angular/core';
import { MatSpinner } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-typing-indicator',
  templateUrl: './typing-indicator.component.html',
  styleUrls: ['./typing-indicator.component.scss'],
  standalone: true,
  imports: [MatSpinner],
})
export class TypingIndicatorComponent {
  @Input() isVisible = false;
  @Input() message = 'Generating response...';
}
